const config = {
  'shenzhen': {
    location: {
      CH: '深圳',
      EN: 'ShenZhen'
    },
    theme: 'as-blue',
    home: {
      nav: {
        version: 'as'
      },
      banner: {
        version: 2,
        videoLink: 'https://constatic.geekbang.org/ASvideo/archsummit2017sz-200m.mp4.mp4'
      },
      review: {
        theme: 'as-blue'
      },
      analytics: {
        theme: 'as-blue'
      }
    },
    about: {
      hotel: {
        version: 'shenzhen'
      }
    },
    comFloatWin: {
      name: '小姐姐 Ring',
      phone: '+86-15600537884',
      qrcode: require('@/assets/img/Ring-as.jpeg')
    }
  },
  'beijing': {
    location: {
      CH: '北京',
      EN: 'BeiJing'
    },
    theme: 'as-blue',
    home: {
      nav: {
        version: 'as'
      },
      banner: {
        version: 2,
        videoLink: 'https://constatic.geekbang.org/ASvideo/archsummit2017sz-200m.mp4.mp4'
      },
      review: {
        theme: 'as-blue'
      },
      analytics: {
        theme: 'as-blue'
      }
    },
    about: {
      hotel: {
        version: 'beijing'
      }
    },
    comFloatWin: {
      name: '小姐姐 Ring',
      phone: '+86-15600537884',
      qrcode: require('@/assets/img/Ring-as.jpeg')
    }
  }
}

export default config
